import { EPSG4326 } from "./EPSG4326"
import { EPSG3857 } from "./EPSG3857"
import { EPSG4490 } from "./EPSG4490"
import { EPSG4545 } from "./EPSG4545"
import { EPSG4546 } from "./EPSG4546"
import { EPSG4547 } from "./EPSG4547"
/**
 * 当前地图支持的所有坐标系信息
 */
const ProjectionDef = {}
const defaultProjs = [
  EPSG4326,
  EPSG3857,
  EPSG4490,
  EPSG4545,
  EPSG4546,
  EPSG4547
]
defaultProjs.forEach(item => {
  ProjectionDef[item.name] = item
})

export default ProjectionDef